<template>
  <component
    :is="priceListComponent"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
    PriceList: () => import('~/components/PriceList/PriceList.vue'),
    PriceListV2: () => import('~/components/PriceList/PriceListNew.vue'),
  },
  computed: {
    ...mapGetters('auth', ['isAuthorized']),
    priceListComponent() {
      return this.isAuthorized ? 'PriceList' : 'PriceListV2';
    },
  },
};
</script>
